import React, { useState } from "react";

const AdeyaVideo = () => {
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [videoToken, setVideoToken] = useState(null);
    const [error, setError] = useState("")

    const API = process.env.REACT_APP_API_URL;

    // const handleSubmit = async (e) =>{
    //     e.preventDefault();

    //     setError("");
    //     if(!phone.trim()){
    //         setError('Please enter your phone number');
    //         return;
    //     }

    //     if(!/^[0-9]{10}$/.test(phone)){
    //         setError('Invalid phone number');
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         const response = await fetch(`${API}/email/lead`,{
    //             method:'POST',
    //             headers:{
    //                 "Content-Type":"application/json"
    //             },
    //             body:JSON.stringify({
    //                 phone,
    //             })
    //         })
    //         const data = await response.json();
    //         if(!response.ok || !data.success){
    //             throw new Error(data.message || "Unable to unlock video")
    //         }

    //         setVideoToken(data.token)
    //     } catch (error) {
    //         console.log('Demo access error', error);
    //         setError(error.message || "Something went wrong. Please try again")
    //     } finally{
    //         setLoading(false)
    //     }
    // };

    // const videoUrl = videoToken ? `${API}/video/video?token=${videoToken}` : null

    const videoUrl = "https://api.adeyaai.com/uploads/videos/Adeya_ims_real_time_1791792659853.mp4";

    return (
        <section className="relative py-16 sm:py-20 overflow-hidden bg-gradient-to-b from-blue-50 via-white to-white">

            {/* Background decoration */}
            <div className="absolute top-0 left-0 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 right-0 w-80 h-80 bg-cyan-200/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

            <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Heading */}
                <div className="text-center max-w-3xl mx-auto mb-10">

                    <span className="inline-flex items-center gap-2 px-4 py-2 mb-4 rounded-full bg-blue-100 text-blue-700 text-xs sm:text-sm font-semibold tracking-wide uppercase">
                        <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse"></span>
                        See Adeya IMS in Action
                    </span>

                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
                        One Platform.
                        <span className="block text-blue-600">
                            Complete Business Control.
                        </span>
                    </h2>

                    <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Discover how Adeya IMS brings your business operations,
                        inventory and workflows together in one powerful platform.
                    </p>

                </div>

                {/* Video Card */}
                <div className="relative group">

                    {/* Blue glow */}
                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-600 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-500"></div>

                    <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden bg-slate-950 border border-blue-100 shadow-2xl">

                        <video
                            controls
                            preload="metadata"
                            playsInline
                            className="w-full h-auto aspect-video object-contain bg-black"
                        >
                            <source
                                src={videoUrl}
                                type="video/mp4"
                            />

                            Your browser does not support video playback.
                        </video>

                    </div>
                </div>

                {/* Bottom points */}
                <div className="mt-8 flex flex-wrap justify-center gap-4 sm:gap-8 text-sm text-slate-600">

                    <div className="flex items-center gap-2">
                        <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                            ✓
                        </span>
                        Easy to Use
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                            ✓
                        </span>
                        Real-Time Operations
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                            ✓
                        </span>
                        Built for Growing Businesses
                    </div>

                </div>

            </div>
        </section>
    );
    // return (
    //     <section className="relative py-16 sm:py-20 overflow-hidden bg-gradient-to-b from-blue-50 via-white to-white">

    //         {/* Background decoration */}
    //         <div className="absolute top-0 left-0 w-72 h-72 bg-blue-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>

    //         <div className="absolute bottom-0 right-0 w-80 h-80 bg-cyan-200/20 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

    //         <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

    //             {/* Heading */}
    //             <div className="text-center max-w-3xl mx-auto mb-10">

    //                 <span className="inline-flex items-center gap-2 px-4 py-2 mb-4 rounded-full bg-blue-100 text-blue-700 text-xs sm:text-sm font-semibold tracking-wide uppercase">
    //                     <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse"></span>

    //                     See Adeya IMS in Action
    //                 </span>

    //                 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">

    //                     One Platform.

    //                     <span className="block text-blue-600">
    //                         Complete Business Control.
    //                     </span>

    //                 </h2>

    //                 <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
    //                     Discover how Adeya IMS brings your business operations,
    //                     inventory and workflows together in one powerful platform.
    //                 </p>

    //             </div>


    //             {/* Video / Form Card */}
    //             <div className="relative group">

    //                 <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-600 rounded-3xl blur opacity-20 group-hover:opacity-30 transition duration-500"></div>

    //                 <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden bg-slate-950 border border-blue-100 shadow-2xl">


    //                     {/* VIDEO AFTER UNLOCK */}
    //                     {videoToken ? (

    //                         <video
    //                             controls
    //                             preload="metadata"
    //                             playsInline
    //                             className="w-full h-auto aspect-video object-contain bg-black"
    //                         >
    //                             <source
    //                                 src={videoUrl}
    //                                 type="video/mp4"
    //                             />

    //                             Your browser does not support video playback.
    //                         </video>

    //                     ) : (

    //                         /* PHONE FORM */
    //                         <div className="min-h-[400px] sm:min-h-[500px] flex items-center justify-center px-6 py-12">

    //                             <div className="w-full max-w-xl text-center">

    //                                 <div className="mx-auto mb-5 flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-100 text-blue-600 text-2xl">
    //                                     ▶
    //                                 </div>

    //                                 <h3 className="text-2xl sm:text-3xl font-bold text-white">
    //                                     Ready to See Adeya IMS in Action?
    //                                 </h3>

    //                                 <p className="mt-3 text-slate-300 text-sm sm:text-base leading-relaxed">
    //                                     See Your Inventory Get Smarter - Watch pre recorded demo instantly
    //                                 </p>

    //                                 <form
    //                                     onSubmit={handleSubmit}
    //                                     className="mt-8"
    //                                 >

    //                                     <div className="text-left">

    //                                         <label className="block text-sm font-medium text-slate-200 mb-2">
    //                                             Phone Number
    //                                         </label>

    //                                         <div className="flex">

    //                                             <span className="flex items-center px-4 bg-slate-800 border border-slate-700 border-r-0 rounded-l-xl text-slate-300">
    //                                                 +91
    //                                             </span>

    //                                             <input
    //                                                 type="tel"
    //                                                 value={phone}
    //                                                 onChange={(e) => {
    //                                                     const value =
    //                                                         e.target.value.replace(
    //                                                             /\D/g,
    //                                                             ""
    //                                                         );

    //                                                     if (value.length <= 10) {
    //                                                         setPhone(value);
    //                                                     }

    //                                                     setError("");
    //                                                 }}
    //                                                 placeholder="Enter your phone number"
    //                                                 className="w-full px-4 py-3.5 bg-slate-800 border border-slate-700 rounded-r-xl text-white placeholder-slate-500 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
    //                                                 disabled={loading}
    //                                             />

    //                                         </div>

    //                                     </div>


    //                                     {error && (
    //                                         <p className="mt-3 text-sm text-red-400 text-left">
    //                                             {error}
    //                                         </p>
    //                                     )}


    //                                     <button
    //                                         type="submit"
    //                                         disabled={loading}
    //                                         className="mt-6 w-full py-3.5 px-6 rounded-xl bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold transition-all duration-200 shadow-lg shadow-blue-600/20"
    //                                     >
    //                                         {loading
    //                                             ? "Unlocking Demo..."
    //                                             : "Watch the Demo →"}
    //                                     </button>

    //                                 </form>

    //                                 <p className="mt-4 text-xs text-slate-500">
    //                                     Enter your number to access the Adeya IMS demo.
    //                                 </p>

    //                             </div>

    //                         </div>

    //                     )}

    //                 </div>

    //             </div>


    //             {/* Bottom points */}
    //             <div className="mt-8 flex flex-wrap justify-center gap-4 sm:gap-8 text-sm text-slate-600">

    //                 <div className="flex items-center gap-2">
    //                     <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
    //                         ✓
    //                     </span>
    //                     Easy to Use
    //                 </div>

    //                 <div className="flex items-center gap-2">
    //                     <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
    //                         ✓
    //                     </span>
    //                     Real-Time Operations
    //                 </div>

    //                 <div className="flex items-center gap-2">
    //                     <span className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
    //                         ✓
    //                     </span>
    //                     Built for Growing Businesses
    //                 </div>

    //             </div>

    //         </div>

    //     </section>
    // );
};

export default AdeyaVideo;